import * as z from "zod";
import { userFacingError } from "../userFacingError";
import { mutator } from "./mutator";

export const updateNetwork = mutator({
  schema: z.object({ networkId: z.string(), name: z.string() }),
  resolve: {
    network: { kind: "network", from: "networkId" },
  },
  permissions: [
    { permission: "network:write", scopeId: ({ args }) => args.network.id },
  ],
  description: "Changes the display name of an existing network.",
  interactionType: "update",
  fn: async ({ tx, args: { network, name } }) => {
    const trimmed = name.trim();
    if (!trimmed) throw userFacingError("Enter a network name.");
    await tx.mutate.networks.update({ id: network.id, name: trimmed });
  },
});
